<template>
  <div class="campaignWrapper">
    <div class="container">
      <h1 v-if="activeCampaigns.length">Promotii ACTIVE</h1>
      <div
        class="row"
        :style="activeCampaigns.length ? 'margin-top: 50px' : ''"
      >
        <div
          class="col-lg-6 col-12 campaign"
          :class="campaign.helperClass != null ? 'active-' + campaign.helperClass : ''"
          :key="campaign.name"
          v-for="campaign in activeCampaigns"
        >
          <div class="shadow">
            <img
              class="visual unselectable"
              :src="campaign.visual2x"
              :srcset="`
                ${campaign.visual} 1x,
                ${campaign.visual2x} 2x,
              `"
              :alt="campaign.name"
            />
          </div>
          <div class="contentWrapper">
            <div class="col-12">
              <div class="row justify-content-center">
                <img
                :style="campaign.logoStyle"
                :src="campaign.logo" />
              </div>
              <div class="row justify-content-center mt-3">
                <h4>
                  {{ campaign.startDate | moment }} -
                  {{ campaign.endDate | moment }}
                </h4>
              </div>
              <div class="row justify-content-center mt-3">
                <buttonComponent
                  class="participa"
                  name="Participa"
                  @click.native="goToCampaign(campaign.name)"
                  text="Participa"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 v-if="toBeShown.length">Promotii INCHEIATE</h1>
      <div class="row" style="margin-top: 50px">
        <div
          v-for="campaign in toBeShown"
          class="col-lg-4 col-12 campaign"
          :class="campaign.helperClass != null ? 'over-' + campaign.helperClass : ''"
          :key="campaign.name"
        >
          <div class="shadow" style="background: #a6b8ce">
            <img
              class="visual unselectable"
              :src="campaign.visual2x"
              :srcset="`
                ${campaign.visual} 1x,
                ${campaign.visual2x} 2x,
              `"
              @click="goToCampaign(campaign.name)"
              :alt="campaign.name"
              :style="' opacity: 0.53; border-radius: 15px; cursor: pointer;'"
            />
          </div>
        </div>
        <buttonComponent
          v-if="showMoreEndedBtn"
          class="participa ml-auto"
          name="showMore"
          @click.native="showMoreEnded()"
          text="Mai multe"
        />
      </div>
    </div>
  </div>
</template>

<script>
import buttonComponent from "@/components/renderers/button-component.vue";
import moment from "moment";

export default {
  name: "multi-campaign",
  components: { buttonComponent },
  props: {
    styles: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return {
      toBeShown: [],
      campaigns: [
        {
          name: "ColgateTotalAutumn2026",
          visual: "/assets/campaigns/ColgateTotalAutumn2026/card-visual.jpg",
          visual2x: "/assets/campaigns/ColgateTotalAutumn2026/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2026-08-15",
          endDate: "2026-10-31"
        },
        {
          name: "ColgateWhiteMoneyBack2026",
          visual: "/assets/campaigns/ColgateWhiteMoneyBack2026/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWhiteMoneyBack2026/card-visual.png",
          helperClass:"height-helper",
          startDate: "2026-07-01",
          endDate: "2026-08-31"
        },
        {
          name: "SummerJoy2026",
          visual: "/assets/campaigns/SummerJoy2026/card-visual.jpg",
          visual2x: "/assets/campaigns/SummerJoy2026/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2026-06-01",
          endDate: "2026-07-31"
        },
        {
          name: "ColgateTotal2026",
          visual: "/assets/campaigns/ColgateTotal2026/card-visual.png",
          visual2x: "/assets/campaigns/ColgateTotal2026/card-visual.png",
          helperClass:"height-helper",
          startDate: "2026-04-01",
          endDate: "2026-05-31"
        },
        {
          name: "ColgatePalmoliveLidl2026",
          visual: "/assets/campaigns/ColgatePalmoliveLidl2026/card-visual.png",
          visual2x: "/assets/campaigns/ColgatePalmoliveLidl2026/card-visual.png",
          helperClass:"height-helper",
          startDate: "2026-03-30",
          endDate: "2026-05-24"
        },
        {
          name: "WomenDay2026",
          visual: "/assets/campaigns/WomenDay2026/card-visual.png",
          visual2x: "/assets/campaigns/WomenDay2026/card-visual.png",
          helperClass:"height-helper",
          startDate: "2026-02-14",
          endDate: "2026-04-13"
        },
        {
          name: "ColgateWomenDay2026",
          visual: "/assets/campaigns/ColgateWomenDay2026/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWomenDay2026/card-visual.png",
          helperClass:"height-helper",
          startDate: "2026-02-01",
          endDate: "2026-03-31"
        },
        {
          name: "ColgateKaufland2025",
          visual: "/assets/campaigns/ColgateKaufland2025/card-visual.jpg",
          visual2x: "/assets/campaigns/ColgateKaufland2025/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2025-11-01",
          endDate: "2025-12-09"
        },
        {
          name: "ColgateWhite2025",
          visual: "/assets/campaigns/ColgateWhite2025/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWhite2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-11-01",
          endDate: "2025-12-31"
        },
        {
          name: "ColgateLLDP2025",
          visual: "/assets/campaigns/ColgateLLDP2025/card-visual.png",
          visual2x: "/assets/campaigns/ColgateLLDP2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-09-01",
          endDate: "2025-09-30"
        },
        {
          name: "ColgateLidl2025",
          visual: "/assets/campaigns/ColgateLidl2025/card-visual.png",
          visual2x: "/assets/campaigns/ColgateLidl2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-09-01",
          endDate: "2025-10-05"
        },
        {
          name: "ColgateTotalActivePrevention2025",
          visual: "/assets/campaigns/ColgateTotalActivePrevention2025/card-visual.png",
          visual2x: "/assets/campaigns/ColgateTotalActivePrevention2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-08-06",
          endDate: "2025-10-15"
        },
        {
          name: "LidlBeauty2025",
          visual: "/assets/campaigns/LidlBeauty2025/card-visual.png",
          visual2x: "/assets/campaigns/LidlBeauty2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-07-20",
          endDate: "2025-08-20"
        },
        {
          name: "ColgateWhiteMoneyBack2025",
          visual: "/assets/campaigns/ColgateWhiteMoneyBack2025/card-visual.jpg",
          visual2x: "/assets/campaigns/ColgateWhiteMoneyBack2025/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2025-06-15",
          endDate: "2025-08-15"
        },
        {
          name: "SummerJoy2025",
          visual: "/assets/campaigns/SummerJoy2025/card-visual.jpg",
          visual2x: "/assets/campaigns/SummerJoy2025/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2025-06-01",
          endDate: "2025-07-31"
        },
        {
          name: "CarrefourAniversar2025",
          visual: "/assets/campaigns/CarrefourAniversar2025/card-visual.png",
          visual2x: "/assets/campaigns/CarrefourAniversar2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-05-07",
          endDate: "2025-06-03"
        },
        {
          name: "IngrijirePersonalaKaufland2025",
          visual: "/assets/campaigns/IngrijirePersonalaKaufland2025/card-visual.png",
          visual2x: "/assets/campaigns/IngrijirePersonalaKaufland2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-04-02",
          endDate: "2025-06-03"
        },
        {
          name: "ColgateTotal2025",
          visual: "/assets/campaigns/ColgateTotal2025/card-visual.png",
          visual2x: "/assets/campaigns/ColgateTotal2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-04-01",
          endDate: "2025-05-31"
        },
        {
          name: "SpringCleaning2025",
          visual: "/assets/campaigns/SpringCleaning2025/card-visual.jpg",
          visual2x: "/assets/campaigns/SpringCleaning2025/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2025-03-01",
          endDate: "2025-04-30"
        },
        {
          name: "ElmexMoneyBack2025",
          visual: "/assets/campaigns/ElmexMoneyBack2025/card-visual.jpg",
          visual2x: "/assets/campaigns/ElmexMoneyBack2025/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2025-03-01",
          endDate: "2025-05-31"
        },
        {
          name: "WomenDay2025",
          visual: "/assets/campaigns/WomenDay2025/card-visual.jpg",
          visual2x: "/assets/campaigns/WomenDay2025/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2025-02-01",
          endDate: "2025-03-31"
        },
        {
          name: "ColgateWomenDay2025",
          visual: "/assets/campaigns/ColgateWomenDay2025/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWomenDay2025/card-visual.png",
          helperClass:"height-helper",
          startDate: "2025-02-01",
          endDate: "2025-03-31"
        },
        {
          name: "Protexcashback2025",
          visual: "/assets/campaigns/Protexcashback2025/card-visual.jpg",
          visual2x: "/assets/campaigns/Protexcashback2025/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2025-01-01",
          endDate: "2025-02-28"
        },
        {
          name: "ColgateWhitening2024",
          visual: "/assets/campaigns/ColgateWhitening2024/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWhitening2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-10-30",
          endDate: "2024-12-31"
        },
        {
          name: "Protex2024",
          visual: "/assets/campaigns/Protex2024/card-visual.jpg",
          visual2x: "/assets/campaigns/Protex2024/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2024-10-01",
          endDate: "2024-11-30"
        },
        {
          name: "PalmoliveChristmas2024",
          visual: "/assets/campaigns/PalmoliveChristmas2024/card-visual.png",
          visual2x: "/assets/campaigns/PalmoliveChristmas2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-10-01",
          endDate: "2024-11-30"
        },
        {
          name: "ColgateOHMLDP2024",
          visual: "/assets/campaigns/ColgateOHMLDP2024/card-visual.png",
          visual2x: "/assets/campaigns/ColgateOHMLDP2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-09-01",
          endDate: "2024-09-30"
        },
        {
          name: "ColgateOHM2024",
          visual: "/assets/campaigns/ColgateOHM2024/card-visual.png",
          visual2x: "/assets/campaigns/ColgateOHM2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-08-15",
          endDate: "2024-10-15"
        },
        {
          name: "PalmoliveLifestyle2024",
          visual: "/assets/campaigns/PalmoliveLifestyle2024/card-visual.jpg",
          visual2x: "/assets/campaigns/PalmoliveLifestyle2024/card-visual.jpg",
          helperClass:"height-helper",
          startDate: "2024-07-30",
          endDate: "2024-08-20"
        },
        // {
        //   name: "ElmexMoneyBack2024",
        //   visual: "/assets/campaigns/ElmexMoneyBack2024/card-visual.png",
        //   visual2x: "/assets/campaigns/ElmexMoneyBack2024/card-visual.png",
        //   helperClass:"height-helper",
        //   startDate: "2024-07-01",
        //   endDate: "2024-09-30"
        // },
        {
          name: "ColgateWhiteMoneyBack2024",
          visual: "/assets/campaigns/ColgateWhiteMoneyBack2024/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWhiteMoneyBack2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-06-15",
          endDate: "2024-08-15"
        },
        {
          name: "SummerExperience2024",
          visual: "/assets/campaigns/SummerExperience2024/card-visual.png",
          visual2x: "/assets/campaigns/SummerExperience2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-06-01",
          endDate: "2024-08-31"
        },
        {
          name: "CarrefourAniversar2024",
          visual: "/assets/campaigns/CarrefourAniversar2024/card-visual.png",
          visual2x: "/assets/campaigns/CarrefourAniversar2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-05-22",
          endDate: "2024-06-18"
        },
        {
          name: "ColgateWhiteningSelgros2024",
          visual: "/assets/campaigns/ColgateWhiteningSelgros2024/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWhiteningSelgros2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-05-03",
          endDate: "2024-05-30"
        },
        {
          name: "ColgateTotal2024",
          visual: "/assets/campaigns/ColgateTotal2024/card-visual.png",
          visual2x: "/assets/campaigns/ColgateTotal2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-04-01",
          endDate: "2024-05-31"
        },
        {
          name: "Springcleaning2024",
          visual: "/assets/campaigns/Springcleaning2024/card-visual.png",
          visual2x: "/assets/campaigns/Springcleaning2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-03-01",
          endDate: "2024-04-30"
        },
        {
          name: "WomenDay2024",
          visual: "/assets/campaigns/WomenDay2024/card-visual.png",
          visual2x: "/assets/campaigns/WomenDay2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2024-02-01",
          endDate: "2024-03-31"
        },
        {
          name: "ColgateWomenDay2024",
          visual: "/assets/campaigns/ColgateWomenDay2024/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWomenDay2024/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-02-01",
          endDate: "2024-03-31"
        },
        {
          name: "Elmex2023",
          visual: "/assets/campaigns/Elmex2023/card-visual.png",
          visual2x: "/assets/campaigns/Elmex2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-10-01",
          endDate: "2023-12-31"
        },
        {
          name: "Autumncleaning2023",
          visual: "/assets/campaigns/Autumncleaning2023/key-visual.png",
          visual2x: "/assets/campaigns/Autumncleaning2023/key-visual.png",
          helperClass:"height-helper",
          startDate: "2023-10-01",
          endDate: "2023-11-30"
        },
        {
          name: "ProtexHealthProtection2023",
          visual: "/assets/campaigns/ProtexHealthProtection2023/key-visual.jpg",
          visual2x: "/assets/campaigns/ProtexHealthProtection2023/key-visual.jpg",
          helperClass:"height-helper",
          startDate: "2023-09-15",
          endDate: "2023-11-15"
        },
        {
          name: "ColgateSeptember2023",
          visual: "/assets/campaigns/ColgateSeptember2023/key-visual.png",
          visual2x: "/assets/campaigns/ColgateSeptember2023/key-visual.png",
          logo: "/assets/ladoipasi_logo.png",
          startDate: "2023-09-05",
          endDate: "2023-09-30"
        },
        {
          name: "ColgateIT",
          visual: "/assets/campaigns/ColgateIT/card-visual.png",
          visual2x: "/assets/campaigns/ColgateIT/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-09-01",
          endDate: "2023-10-31"
        },
        {
          name: "ColgateSummer2023",
          visual: "/assets/campaigns/ColgateSummer2023/key-visual.png",
          visual2x: "/assets/campaigns/ColgateSummer2023/key-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2023-08-22",
          endDate: "2023-09-30"
        },
        {
          name: "ColgateSummerKaufland2023",
          visual: "/assets/campaigns/ColgateSummerKaufland2023/card-visual.png",
          visual2x: "/assets/campaigns/ColgateSummerKaufland2023/card-visual.png",
          logo: "/assets/kaufland_logo.png",
          startDate: "2023-08-17",
          endDate: "2023-09-30"
        },
        {
          name: "Ladyspeedstick2023",
          visual: "/assets/campaigns/Ladyspeedstick2023/card-visual.png",
          visual2x: "/assets/campaigns/Ladyspeedstick2023/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2023-08-08",
          endDate: "2023-08-22"
        },
        // {
        //   name: "ColgateUltra2023",
        //   visual: "/assets/campaigns/ColgateUltra2023/card-visual.png",
        //   visual2x: "/assets/campaigns/ColgateUltra2023/card-visual.png",
        //   helperClass:"height-helper",
        //   startDate: "2023-07-15",
        //   endDate: "2023-08-31"
        // },
        {
          name: "PalmoliveSummer2023",
          visual: "/assets/campaigns/PalmoliveSummer2023/card-visual.png",
          visual2x: "/assets/campaigns/PalmoliveSummer2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-06-27",
          endDate: "2023-08-31"
        },
        {
          name: "ColgateWhitening2023",
          visual: "/assets/campaigns/ColgateWhitening2023/card-visual.png",
          visual2x: "/assets/campaigns/ColgateWhitening2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-06-19",
          endDate: "2023-08-19"
        },
        {
          name: "ElmexIT2023",
          visual: "/assets/campaigns/ElmexIT2023/card-visual.png",
          visual2x: "/assets/campaigns/ElmexIT2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-05-01",
          endDate: "2023-06-30"
        },
        {
          name: "PalmoliveExperentials2023",
          visual: "/assets/campaigns/PalmoliveExperentials2023/card-visual.png",
          visual2x: "/assets/campaigns/PalmoliveExperentials2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-05-01",
          endDate: "2023-06-30"
        },
        {
          name: "ColgatePalmolive2023",
          visual: "/assets/campaigns/ColgatePalmolive2023/card-visual.png",
          visual2x: "/assets/campaigns/ColgatePalmolive2023/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2023-05-03",
          endDate: "2023-05-30"
        },
        {
          name: "AjaxAxion2023",
          visual: "/assets/campaigns/AjaxAxion2023/card-visual.png",
          visual2x: "/assets/campaigns/AjaxAxion2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-03-01",
          endDate: "2023-04-30"
        },
        {
          name: "Elmex-MB2023",
          visual: "/assets/campaigns/Elmex-MB2023/card-visual.png",
          visual2x: "/assets/campaigns/Elmex-MB2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-03-01",
          endDate: "2023-05-31"
        },
        {
          name: "ColgateTotal2023",
          visual: "/assets/campaigns/ColgateTotal2023/card-visual.png",
          visual2x: "/assets/campaigns/ColgateTotal2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-03-01",
          endDate: "2023-04-30"
        },
        {
          name: "ColgateMaxAuchan2023",
          visual: "/assets/campaigns/ColgateMaxAuchan2023/card-visual.png",
          visual2x: "/assets/campaigns/ColgateMaxAuchan2023/card-visual.png",
          logo: "/assets/auchan_logo.png",
          startDate: "2023-02-08",
          endDate: "2023-03-08"
        },
        {
          name: "ColgateMax2023",
          visual: "/assets/campaigns/ColgateMax2023/card-visual.png",
          visual2x: "/assets/campaigns/ColgateMax2023/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2023-02-10",
          endDate: "2023-03-09"
        },
        {
          name: "Palmolive2023",
          visual: "/assets/campaigns/Palmolive2023/card-visual.png",
          visual2x: "/assets/campaigns/Palmolive2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-02-01",
          endDate: "2023-03-31"
        },
        {
          name: "Protex2023",
          visual: "/assets/campaigns/Protex2023/card-visual.png",
          visual2x: "/assets/campaigns/Protex2023/card-visual.png",
          helperClass:"height-helper",
          startDate: "2023-01-15",
          endDate: "2023-03-15"
        },
        {
          name: "ColgateCharcoal",
          visual: "/assets/campaigns/ColgateCharcoal/card-visual.png",
          visual2x: "/assets/campaigns/ColgateCharcoal/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-12-15",
          endDate: "2023-01-13"
        },
        {
          name: "AutumnCleaning2022",
          visual: "/assets/campaigns/AutumnCleaning2022/card-visual.png",
          visual2x: "/assets/campaigns/AutumnCleaning2022/card-visual.png",
          helperClass:"height-helper",
          startDate: "2022-10-01",
          endDate: "2022-12-15"
        },
        {
          name: "ProtexSummerRomania",
          visual: "/assets/campaigns/ProtexSummerRomania/card-visual.png",
          visual2x: "/assets/campaigns/ProtexSummerRomania/card-visual.png",
          helperClass:"height-helper",
          startDate: "2022-09-01",
          endDate: "2022-11-30"
        },
        {
          name: "ElmexAugust2022",
          visual: "/assets/campaigns/ElmexAugust2022/card-visual.png",
          visual2x: "/assets/campaigns/ElmexAugust2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-08-25",
          endDate: "2022-09-22"
        },
        {
          name: "ColgateAugust2022",
          visual: "/assets/campaigns/ColgateAugust2022/card-visual.png",
          visual2x: "/assets/campaigns/ColgateAugust2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-08-25",
          endDate: "2022-09-22"
        },
        {
          name: "ProtexSummerCarrefour2022",
          visual: "/assets/campaigns/ProtexSummerCarrefour2022/card-visual.png",
          visual2x: "/assets/campaigns/ProtexSummerCarrefour2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-08-11",
          endDate: "2022-09-11"
        },
        {
          name: "Moneyback2022",
          visual: "/assets/campaigns/Moneyback2022/card-visual.png",
          visual2x: "/assets/campaigns/Moneyback2022/card-visual.png",
          helperClass:"height-helper",
          startDate: "2022-07-01",
          endDate: "2022-08-31"
        },
        {
          name: "PalmoliveSmoothies2022",
          visual: "/assets/campaigns/PalmoliveSmoothies2022/card-visual.png",
          visual2x: "/assets/campaigns/PalmoliveSmoothies2022/card-visual.png",
          helperClass:"height-helper",
          startDate: "2022-07-01",
          endDate: "2022-08-31"
        },
        {
          name: "PalmoliveCarrefourJune2022",
          visual: "/assets/campaigns/PalmoliveCarrefourJune2022/card-visual.png",
          visual2x: "/assets/campaigns/PalmoliveCarrefourJune2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-06-20",
          endDate: "2022-07-20"
        },
        {
          name: "ElmexCarrefourJuly2022",
          visual: "/assets/campaigns/ElmexCarrefourJuly2022/card-visual.png",
          visual2x: "/assets/campaigns/ElmexCarrefourJuly2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-06-09",
          endDate: "2022-07-09"
        },
        {
          name: "ActiveLifestyleMega",
          visual: "/assets/campaigns/ActiveLifestyleMega/card-visual.png",
          visual2x: "/assets/campaigns/ActiveLifestyleMega/card-visual.png",
          logo: "/assets/mega_logo.png",
          logoStyle:"margin-top:-10% !important",
          startDate: "2022-05-26",
          endDate: "2022-06-26"
        },
        {
          name: "ActiveLifestyleCarrefour",
          visual: "/assets/campaigns/ActiveLifestyleCarrefour/card-visual.png",
          visual2x: "/assets/campaigns/ActiveLifestyleCarrefour/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-05-12",
          endDate: "2022-06-12"
        },
        {
          name: "ActiveLifestyleCora",
          visual: "/assets/campaigns/ActiveLifestyleCora/card-visual.png",
          visual2x: "/assets/campaigns/ActiveLifestyleCora/card-visual.png",
          logo: "/assets/cora_logo.png",
          logoStyle:"margin-top:-6% !important",
          startDate: "2022-05-11",
          endDate: "2022-06-11"
        },
        {
          name: "ProtexCharcoalCarrefour2022",
          visual: "/assets/campaigns/ProtexCharcoalCarrefour2022/card-visual.png",
          visual2x: "/assets/campaigns/ProtexCharcoalCarrefour2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-04-28",
          endDate: "2022-05-28"
        },
        {
          name: "ProtexCharcoalMega2022",
          visual: "/assets/campaigns/ProtexCharcoalMega2022/card-visual.png",
          visual2x: "/assets/campaigns/ProtexCharcoalMega2022/card-visual.png",
          logo: "/assets/mega_logo.png",
          logoStyle:"margin-top:-10% !important",
          startDate: "2022-04-28",
          endDate: "2022-05-25"
        },
        {
          name: "ColgateCarrefour21Ani",
          visual: "/assets/campaigns/ColgateCarrefour21Ani/card-visual.png",
          visual2x: "/assets/campaigns/ColgateCarrefour21Ani/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-04-28",
          endDate: "2022-05-25"
        },
        {
          name: "ProtexCharcoalCora2022",
          visual: "/assets/campaigns/ProtexCharcoalCora2022/card-visual.png",
          visual2x: "/assets/campaigns/ProtexCharcoalCora2022/card-visual.png",
          logo: "/assets/cora_logo.png",
          logoStyle:"margin-top:-6% !important",
          startDate: "2022-04-27",
          endDate: "2022-05-27"
        },
        {
          name: "SpringCleaningCarrefour2022",
          visual: "/assets/campaigns/SpringCleaningCarrefour2022/card-visual.png",
          visual2x: "/assets/campaigns/SpringCleaningCarrefour2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-03-24",
          endDate: "2022-04-24"
        },
        {
          name: "SpringCleaningMega2022",
          visual: "/assets/campaigns/SpringCleaningMega2022/card-visual.png",
          visual2x: "/assets/campaigns/SpringCleaningMega2022/card-visual.png",
          logo: "/assets/mega_logo.png",
          logoStyle:"margin-top:-10% !important",
          startDate: "2022-03-24",
          endDate: "2022-04-24"
        },
        {
          name: "SpringCleaningCora2022",
          visual: "/assets/campaigns/SpringCleaningCora2022/card-visual.png",
          visual2x: "/assets/campaigns/SpringCleaningCora2022/card-visual.png",
          logo: "/assets/cora_logo.png",
          logoStyle:"margin-top:-6% !important",
          startDate: "2022-03-23",
          endDate: "2022-04-23"
        },
        {
          name: "ColgateTotalCarrefour2022",
          visual: "/assets/campaigns/ColgateTotalCarrefour2022/card-visual.png",
          visual2x: "/assets/campaigns/ColgateTotalCarrefour2022/card-visual.png",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-03-17",
          endDate: "2022-04-17"
        },
        {
          name: "ColgateTotalDM2022",
          visual: "/assets/campaigns/ColgateTotalDM2022/card-visual.jpg",
          visual2x: "/assets/campaigns/ColgateTotalDM2022/card-visual.jpg",
          logo: "/assets/dm_logo.png",
          logoStyle:"margin-top:-14% !important",
          startDate: "2022-03-09",
          endDate: "2022-04-09"
        },
        {
          name: "ColgateTotalMegaImage2022",
          visual: "/assets/campaigns/ColgateTotalMegaImage2022/card-visual.jpg",
          visual2x: "/assets/campaigns/ColgateTotalMegaImage2022/card-visual.jpg",
          logo: "/assets/mega_logo.png",
          logoStyle:"margin-top:-10% !important",
          startDate: "2022-02-24",
          endDate: "2022-03-30"
        },
        {
          name: "MegaImage2022",
          visual: "/assets/campaigns/MegaImage2022/card-visual.jpg",
          visual2x: "/assets/campaigns/MegaImage2022/card-visual.jpg",
          logo: "/assets/mega_logo.png",
          logoStyle:"margin-top:-10% !important",
          startDate: "2022-02-24",
          endDate: "2022-03-30"
        },
        {
          name: "Carrefour2022",
          visual: "/assets/campaigns/Carrefour2022/card-visual.jpg",
          visual2x: "/assets/campaigns/Carrefour2022/card-visual.jpg",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-02-24",
          endDate: "2022-03-24"
        },
        {
          name: "ColgateWhiteningCarrefour2022",
          visual: "/assets/campaigns/ColgateWhiteningCarrefour2022/card-visual.jpg",
          visual2x: "/assets/campaigns/ColgateWhiteningCarrefour2022/card-visual.jpg",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-02-17",
          endDate: "2022-03-23"
        },
        {
          name: "ElmexAuchanFeb2022",
          visual: "/assets/campaigns/ElmexAuchanFeb2022/card-visual.jpg",
          visual2x: "/assets/campaigns/ElmexAuchanFeb2022/card-visual.jpg",
          logo: "/assets/auchan_logo.png",
          startDate: "2022-02-16",
          endDate: "2022-03-16"
        },
        {
          name: "ElmexMegaFeb2022",
          visual: "/assets/campaigns/ElmexMegaFeb2022/card-visual.jpg",
          visual2x: "/assets/campaigns/ElmexMegaFeb2022/card-visual.jpg",
          logo: "/assets/mega_logo.png",
          logoStyle:"margin-top:-10% !important",
          startDate: "2022-02-14",
          endDate: "2022-03-14"
        },
        {
          name: "ElmexCarrefourFeb2022",
          visual: "/assets/campaigns/ElmexCarrefourFeb2022/card-visual.jpg",
          visual2x: "/assets/campaigns/ElmexCarrefourFeb2022/card-visual.jpg",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-02-10",
          endDate: "2022-03-10"
        },
        {
          name: "Auchan2022",
          visual: "/assets/campaigns/Auchan2022/card-visual.jpg",
          visual2x: "/assets/campaigns/Auchan2022/card-visual.jpg",
          logo: "/assets/auchan_logo.png",
          startDate: "2022-02-09",
          endDate: "2022-03-08"
        },
        {
          name: "ColgateWhiteningAuchan2022",
          visual:
            "/assets/campaigns/ColgateWhiteningAuchan2022/card-visual.png",
          visual2x:
            "/assets/campaigns/ColgateWhiteningAuchan2022/card-visual.png",
          logo: "/assets/auchan_logo.png",
          startDate: "2022-02-09",
          endDate: "2022-03-08"
        },
        {
          name: "ColgateElixirCarrefour2022",
          visual:
            "/assets/campaigns/ColgateElixirCarrefour2022/card-visual.jpg",
          visual2x:
            "/assets/campaigns/ColgateElixirCarrefour2022/card-visual.jpg",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-02-03",
          endDate: "2022-03-03"
        },
        {
          name: "ProtexCarrefourJan2022",
          visual: "/assets/campaigns/ProtexCarrefourJan2022/card-visual.jpg",
          visual2x: "/assets/campaigns/ProtexCarrefourJan2022/card-visual.jpg",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-01-13",
          endDate: "2022-02-13"
        },
        {
          name: "ColgateEquityCarrefourJan2022",
          visual:
            "/assets/campaigns/ColgateEquityCarrefourJan2022/card-visual.jpg",
          visual2x:
            "/assets/campaigns/ColgateEquityCarrefourJan2022/card-visual.jpg",
          logo: "/assets/carrefour_logo.png",
          startDate: "2022-01-13",
          endDate: "2022-02-13"
        },
        {
          name: "ProtexCarrefour",
          visual: "/assets/campaigns/ProtexCarrefour/card-visual.jpg",
          visual2x: "/assets/campaigns/ProtexCarrefour/card-visual.jpg",
          logo: "/assets/carrefour_logo.png",
          startDate: "2021-12-09",
          endDate: "2022-01-09"
        }
      ]
    };
  },
  computed: {
    srcset() {
      if (this.imageSource3x) {
        return `${this.imageSource} 1x, ${this.imageSource2x} 2x, ${this.imageSource3x} 3x`;
      } else if (this.imageSource2x) {
        return `${this.imageSource} 1x, ${this.imageSource2x} 2x`;
      }
      return `${this.imageSource} 1x`;
    },
    activeCampaigns() {
      return this.campaigns.filter((x) => {
        const startDate = new Date(
          new Date(x.startDate).setHours(0, 0, 0, 0)
        ).toLocaleString("en-US");
        const endDate = new Date(
          new Date(x.endDate).setHours(0, 0, 0, 0)
        ).toLocaleString("en-US");
        const currentTime = new Date().toLocaleString("en-US", {
          timeZone: "Europe/Bucharest"
        });
        const dayInSeconds = 86400; // If we need to include the ending day
        const isTestVersion = this.$route.query.version === "test";

        return (
          (isTestVersion ||
            new Date(startDate).getTime() / 1000 <=
              new Date(currentTime).getTime() / 1000) &&
          new Date(endDate).getTime() / 1000 + dayInSeconds >=
            new Date(currentTime).getTime() / 1000
        );
      });
    },
    endedCampaigns() {
      return this.campaigns.filter((x) => {
        const endDate = new Date(
          new Date(x.endDate).setHours(0, 0, 0, 0)
        ).toLocaleString("en-US");
        const currentTime = new Date().toLocaleString("en-US", {
          timeZone: "Europe/Bucharest"
        });
        const dayInSeconds = 86400; // If we need to include the ending day

        return (
          new Date(endDate).getTime() / 1000 + dayInSeconds <
          new Date(currentTime).getTime() / 1000
        );
      });
    },
    showMoreEndedBtn () {
      return this.endedCampaigns.length > this.toBeShown.length
    }
  },
  mounted () {
    this.toBeShown = this.endedCampaigns.slice(0, 6)
  },
  methods: {
    goToCampaign(page) {
      const campaign = require(`../../store/campaigns/${page}`).default;
      campaign.pageProperties.testing =
        this.$store.state.pageProperties.testing;
      this.$store.replaceState(campaign);

      setTimeout(() => {
        this.goToPage(page, this);
      }, 10);
    },
    showMoreEnded() {
      this.toBeShown = this.endedCampaigns
    }
  },
  filters: {
    moment: function (date) {
      return moment(date).format("DD.MM.YYYY");
    }
  }
};
</script>

<style lang="scss">
.campaignWrapper {
  margin: 30px 0 30px 0;

  @media (max-width: 992px) {
    margin: 40px 0 0;
  }

  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }

  .separator::before,
  .separator::after {
    content: "";
    flex: 1;
    border-bottom: 1px solid #d9d9d9;
  }

  .separator:not(:empty)::before {
    margin-right: 0.25em;
  }

  .separator:not(:empty)::after {
    margin-left: 0.25em;
  }
}

.contentWrapper {
  background: #ffffff;
  box-shadow: 0px 16px 32px -3px #e2e8f9;
  border-radius: 0px 0px 15px 15px;
  padding: 20px 0;
}

.campaign {
  font: normal normal medium 18px/18px "Plus Jakarta Sans";
  margin-bottom: 40px;

  .visual {
    width: 100%;
    height: 100%;
    max-height: 362px;
    border-radius: 15px 15px 0px 0px;
  }

  .shadow {
    border-radius: 20px;
  }

  .participa {
    height: 45px;
    font-size: 16px;
  }

}
.active-height-helper{
  .visual {
    min-height: 390px;
    @media(max-width: 1199px)
    {
      min-height: 330px;
    }
  }
}
.over-height-helper {
  .visual {
    max-height: 234px;
  }
  @media (max-width: 1200px) {
    .visual {
      max-height: 192px;
    }
  }
    @media (max-width: 992px) {
    .visual {
      max-height: 362px;
    }
  }
}

</style>